import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function Flow() {
  const block = document.querySelector('.devFlow');
  const container = document.querySelector('.devFlow-inner');
  const scrollImg = document.querySelector('.devFlow__flow--scroll');
  const blockWidth = block.offsetWidth;
  const paddingWidth = parseFloat(
    window.getComputedStyle(container).paddingRight
  );
  const scrollImgWidth = scrollImg.offsetWidth;

  gsap.to(scrollImg, {
    x: -scrollImgWidth - paddingWidth + blockWidth,
    ease: 'none',
    scrollTrigger: {
      trigger: block,
      pin: true,
      scrub: 1,
      // markers: true,
      end: () => '+=' + scrollImgWidth,
    },
  });
}

export default Flow;
